import React from 'react';
import MarketingELearningCard from './MarketingELearningCard';
import MarketingELearningShell from './MarketingELearningShell';
import { demoMyPathModules } from './marketingStepDemoData';
import './MarketingAssets.css';

const completeLength = demoMyPathModules.filter((m) => m.isCompleted).length;

/** V1 E-Learning — My Path tab (production markup). */
const MarketingMyPathBoardPreview = () => (
    <MarketingELearningShell activeTab={2}>
        <section className="paragraph-3 ModuleDescription">
            <p className="TitleContentElearning">
                My Personalized Path: {completeLength}/{demoMyPathModules.length}
            </p>
            <span>PHASE 3:</span> A new module unlocks every 30-days for 9
            months
        </section>
        <div className="eLearningBoard__modules OolaScroll MyPathhModules__container">
            {demoMyPathModules.map((item, i) => (
                <MarketingELearningCard
                    key={item.id}
                    item={item}
                    showLeftBorder={i % 2 === 1}
                />
            ))}
        </div>
    </MarketingELearningShell>
);

export default MarketingMyPathBoardPreview;
